import React from 'react'
import PropTypes from 'prop-types'
import AutoComplete from 'material-ui/AutoComplete'
import RaisedButton from 'material-ui/RaisedButton'
import Page from '../common/page/Page'
import Options from './Options'
import Poll from '../../models/Poll'
import predict from '../../services/prediction/question'
import './Create.less'

const meta = {
	title: 'Create poll',
	description: 'Create your own poll with any question you like and easily send it to people.',
}

export default class Create extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			question: '',
		}

		this.handleChange = (question) => {
			const index = this.state.questions.indexOf(question)
			const options = index > -1 ?
				this.props.polls[index].options :
				predict(question)

			this.setState({
				options,
				question,
			})
		}

		this.handleSubmit = (event) => {
			event.preventDefault()
			if (this.refOptions.validate()) {
				this.props.submit({
					question: this.state.question,
					options: this.refOptions.getValues(),
				})
			}
		}
	}

	componentWillMount() {
		this.update(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.update(nextProps)
	}

	update({ polls }) {
		this.setState({
			optionsHistory: polls.map(({ options }) => options),
			questions: polls.map(({ question }) => question),
		})
	}

	render() {
		return (
			<Page className="create" {...meta} showBack>
				<form onSubmit={this.handleSubmit}>
					<AutoComplete
						dataSource={this.state.questions}
						filter={AutoComplete.fuzzyFilter}
						floatingLabelText="What do you want to ask?"
						fullWidth
						maxSearchResults={5}
						onFocus={(event) => event.target.select()}
						onUpdateInput={this.handleChange}
						required
						value={this.state.question}
					/>
					<Options
						history={this.state.optionsHistory}
						predictions={this.state.options}
						ref={(elm) => (this.refOptions = elm)}
					/>
					<div className="actions">
						<RaisedButton label="Send Poll…" primary type="submit" />
					</div>
				</form>
			</Page>
		)
	}
}

Create.propTypes = {
	polls: PropTypes.arrayOf(PropTypes.instanceOf(Poll)),
	submit: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/create/Create.jsx